/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Brand_Availability_InvalidInputs */

const en_error_brand_availability_invalid = /** @type {(inputs: Error_Brand_Availability_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The availability cannot be saved: check the fields marked.`)
};

/**
* | output |
* | --- |
* | "The availability cannot be saved: check the fields marked." |
*
* @param {Error_Brand_Availability_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_brand_availability_invalid = /** @type {((inputs?: Error_Brand_Availability_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Brand_Availability_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_brand_availability_invalid(inputs)
});